import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CARNET_ACCENTS } from "@/data/constants";
import { ArrowRight, Lock, Sparkles } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function Univers() {
  const [universes, setUniverses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/adventure/books").then((r) => setUniverses(r.data || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <section className="relative overflow-hidden bg-[#1F2A24] text-[#F6F2E9]">
        <div className="absolute inset-0 opacity-30" style={{ background: "radial-gradient(circle at 25% 20%, #385E3A55, transparent 60%), radial-gradient(circle at 80% 70%, #C9A24B33, transparent 55%)" }} />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-8 py-20 md:py-24 text-center">
          <p className="font-sans text-xs uppercase tracking-[0.3em] text-[#C9A24B] font-semibold">Le Tao des 4 C</p>
          <h1 className="font-serif text-4xl md:text-6xl mt-4">Les Univers</h1>
          <div className="gold-divider w-24 mx-auto my-6" />
          <p className="font-sans text-sm text-[#F6F2E9]/75 max-w-2xl mx-auto leading-relaxed">
            Chaque univers est un monde à explorer. Vous choisissez un univers, puis la façon dont vous voulez le vivre :
            vivre l'histoire, jouer et explorer, ou approfondir.
          </p>
          <p className="font-sans text-xs tracking-[0.2em] text-[#C9A24B] mt-4">CORPS • CŒUR • CERVEAU • CONSCIENCE</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-8 py-14 md:py-20">
        {loading ? (
          <p data-testid="univers-loading" className="text-center font-sans text-[#1F2A24]/60">Chargement…</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="univers-grid">
            {universes.map((u, i) => (
              <UniverseCard key={u.id} u={u} accent={CARNET_ACCENTS[i % CARNET_ACCENTS.length]} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}

const UniverseCard = ({ u, accent }) => {
  const isIle = u.slug === "ile-de-labondance";
  const to = isIle ? "/univers/ile-de-labondance" : null;
  const coverSrc = isIle
    ? `${BACKEND}/api/game/ile/image/1`
    : (u.cover_url ? `${BACKEND}${u.cover_url}` : null);
  return (
    <div data-testid={`univers-${u.slug}`} className="rounded-2xl bg-white border border-[#E8DCC4] overflow-hidden flex flex-col">
      <div className="aspect-[16/10] relative overflow-hidden" style={{ background: `linear-gradient(150deg, ${accent}, ${accent}bb)` }}>
        {coverSrc && (
          <img src={coverSrc} alt={u.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-90" />
        )}
        <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(31,42,36,0.72), rgba(31,42,36,0.04))" }} />
        <div className="relative h-full flex flex-col justify-between p-5">
          <span className="inline-flex items-center gap-1.5 self-start rounded-full bg-black/25 px-3 py-1 font-sans text-[11px] tracking-wider text-white">
            {u.available ? <Sparkles size={12} /> : <Lock size={12} />}
            {u.available ? "DISPONIBLE" : "BIENTÔT DISPONIBLE"}
          </span>
          <span className="font-serif text-2xl text-white leading-tight drop-shadow-md">{u.title}</span>
        </div>
      </div>
      <div className="p-5 flex flex-col flex-1">
        <p className="font-serif italic text-sm text-[#1F2A24]/75 flex-1 leading-relaxed">{u.tagline}</p>
        <div className="mt-5">
          {to ? (
            <Link to={to} data-testid={`univers-enter-${u.slug}`} className="inline-flex w-full justify-center items-center gap-2 rounded-full bg-[#385E3A] text-white px-5 py-3 font-ui text-sm hover:bg-[#2c4a2e] transition-colors">
              ENTRER DANS L'UNIVERS <ArrowRight size={16} />
            </Link>
          ) : (
            <span className="inline-block w-full text-center rounded-full bg-[#E8DCC4] text-[#1F2A24]/60 px-5 py-3 font-ui text-sm">
              BIENTÔT DISPONIBLE
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
